/**
 * CardGrid Component
 * Displays a grid of cards with hover effects
 */

import React from 'react';

export interface Card {
  title: string;
  description?: string;
  content?: string;
  icon?: string;
  link?: string;
  image?: string;
}

interface CardGridProps {
  cards: Card[];
  columns?: 1 | 2 | 3 | 4;
}

export const CardGrid: React.FC<CardGridProps> = ({ cards, columns = 2 }) => {
  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div className={`ai360-card-grid ai360-card-grid-${columns}`}>
      {cards.map((card, index) => (
        <div key={index} className="ai360-card">
          {card.image && (
            <div className="ai360-card-image">
              <img src={card.image} alt={card.title} />
            </div>
          )}
          <div className="ai360-card-content">
            {card.icon && (
              <span className="ai360-card-icon" role="img" aria-label="icon">
                {card.icon}
              </span>
            )}
            <h3 className="ai360-card-title">{card.title}</h3>
            {card.description && (
              <p className="ai360-card-description">{card.description}</p>
            )}
            {card.content && (
              <div className="ai360-card-text">{card.content}</div>
            )}
            {card.link && (
              <a 
                href={card.link} 
                className="ai360-card-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more →
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
